import React, { useState, useEffect }  from 'react';
import Fulfillments from './fulfillments/fulfillments';
import BelowBelt from './below-belt/below-belt';
import AddToCart from '../shim-components/add-to-cart/add-to-cart';
import NotifyMe from '../shim-components/notify-me/notify-me';
import RequestQuote from '../shim-components/request-quote/request-quote';
import PipModelAdapter from '../shims/pip-model-adapter';

// import './fulfillments/sass/fulfillment_orig.scss';
import './fulfillments/sass/fulfillment.scss';
import './fulfillments/sass/tiles.scss';

import AisleAndBay from '../shim-components/aisle-and-bay/aisle-and-bay';
import ExcludedShipStateMessage from '../shim-components/excluded-shipping/excluded-ship-messaging';
import QuantityInput from '../shims/quantity-input';
import DomAdjuster from '../shims/dom-adjuster';
import LiveGoods from '../shim-components/live-goods/live-goods';

import BossSharedNotification from '../shim-components/boss-shared-notification/boss-shared-notification';
import BuyBeltInit from '../shims/buy-belt-init';

function BuyBelt({
  pipModel={},
  partialReload=false
}) {
  try{
    if(pipModel){
      //TODO: turning off covid message until/unless cookie override is added
      if(window.document.cookie.indexOf("pipBopisCovidMessageOff")===-1){
        pipModel.features = pipModel.features || {};
        pipModel.features.pipBopisCovidMessageOff = false;
      }
      if(window.document.cookie.indexOf("pipBodfsCovidMessageOff")===-1){
        pipModel.features = pipModel.features || {};
        pipModel.features.pipBodfsCovidMessageOff = false;
      }
    }
  }catch(e){
    console.error(e);
  }

  let {
      pickupDetails,
      shippingDetails,
      expressDetails,
      fulfillmentDetails,
      pricingDetails
    } = PipModelAdapter.deriveProps(pipModel);

  const [model, setDetails] =
    useState({
        pickupDetails,
        shippingDetails,
        expressDetails,
        fulfillmentDetails,
        pricingDetails
    });

  let defaultFulfillment = "";
  if(model.pickupDetails.enabled){
    defaultFulfillment = "PICKUP";
  }else if(model.shippingDetails.enabled){
    defaultFulfillment = "STH";
  }else if(model.expressDetails.enabled){
    defaultFulfillment = "EXPRESS";
  }

  const [selectedOption, setSelectedOption] = useState(defaultFulfillment);//PICKUP, STH, EXPRESS
    useEffect(() => {
        if(!selectedOption){
            setSelectedOption(defaultFulfillment);
        }
    },[selectedOption]);


  useEffect(() => {
    fulfillmentDetails.allTilesDisabled = (!pickupDetails.enabled && !shippingDetails.enabled && !expressDetails.enabled);
    BuyBeltInit.finishInitialization(partialReload, fulfillmentDetails, selectedOption);
  }, []);


  const [needMoreShown, toggleNeedMore] = useState(false);

  PipModelAdapter.observeProps(model, setDetails, selectedOption, setSelectedOption);


  const handleOptionClick = (option)=>{
    setSelectedOption(option);
    // QuantityInput.updateTileForBossBopisSharedSku(option, model, setDetails);
    QuantityInput.updateQuantityError(
      option,
      fulfillmentDetails,
      pickupDetails
    );
    DomAdjuster.toggleAssemblyInstallation(option);
    DomAdjuster.toggleSubscription(option);
    DomAdjuster.uncheckInstallation();
  };

  const getDetails = (selected) => {
    if(selected==="PICKUP"){
      return model.pickupDetails;
    }else if(selected==="STH"){
      return model.shippingDetails;
    }else{
      return model.expressDetails;
    }
  };

  const showBuyBeltTitle = () =>{
    return model.fulfillmentDetails.doHideForNotifyMe &&
      !model.fulfillmentDetails.proInstallSelected &&
      !model.fulfillmentDetails.isLiveGood;
  };

  const showLiveGoods = () =>{
    return model.fulfillmentDetails.isLiveGood &&
        model.fulfillmentDetails.availabilityType === "Browse Only" &&
        !model.fulfillmentDetails.bopisEligible &&
        model.fulfillmentDetails.storeQuantity <= 0;
  };

    return (
        <>
          { showBuyBeltTitle() &&
            <span className="u__bold buybelt-title">How to Get It</span>
          }
          <Fulfillments
            selectedOption={selectedOption}
            select={handleOptionClick}
            props={pipModel}
            pickupDetails={model.pickupDetails}
            shippingDetails={model.shippingDetails}
            expressDetails={model.expressDetails}
            fulfillmentDetails={model.fulfillmentDetails}
            showLiveGoods={showLiveGoods()}
          />
          <BelowBelt
            details={getDetails(selectedOption)}
            selectedOption={selectedOption}
            shippingDetails={model.shippingDetails}
            fulfillmentDetails={model.fulfillmentDetails}
            model={model.setSelectedOption}
            needMoreShown={needMoreShown}
            handleToggle={()=>toggleNeedMore(!needMoreShown)}
            showLiveGoods={showLiveGoods()}
            pricingDetails={model.pricingDetails}
          />
          <BossSharedNotification
            pickupDetails={model.pickupDetails}
            fulfillmentDetails={model.fulfillmentDetails}
            needMoreShown={needMoreShown}
            selectedOption={selectedOption}
            handleToggle={()=>toggleNeedMore(!needMoreShown)}
          />
          <NotifyMe
            fulfillmentDetails={model.fulfillmentDetails}
          />
          <AddToCart
            selectedOption={selectedOption}
            fulfillmentDetails={model.fulfillmentDetails}
            pickupDetails={model.pickupDetails}
            shippingDetails={shippingDetails}
            expressDetails={model.expressDetails}
            itemId={pipModel.primaryItemData?pipModel.primaryItemData.itemId:""}
            handleToggle={()=>toggleNeedMore(!needMoreShown)}
            needMoreShown={needMoreShown}
          />
          <AisleAndBay
            fulfillmentDetails={model.fulfillmentDetails}
            pickupDetails={model.pickupDetails}
            />
          <ExcludedShipStateMessage
            fulfillmentDetails={model.fulfillmentDetails}
          />
          {model.fulfillmentDetails.proInstallSelected && (
            <RequestQuote />
          )}
          { showLiveGoods() && (
            <LiveGoods fulfillmentDetails={model.fulfillmentDetails}/>
          )}
        </>
      );
}

export default BuyBelt;
